// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "customer-260421-1/static/css/" + chunkId + "." + {"164":"d7dc8702","710":"d7dc8702","2280":"5132f0ec","2395":"d7dc8702","2473":"5132f0ec","2918":"5132f0ec","2982":"07a465cd","4767":"d7dc8702","7010":"5132f0ec"}[chunkId] + ".chunk.css";
};